module.exports = __webpack_public_path__ + "img/pageBanner-aboutKH.fd3b2ef4.jpg";